<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" app clipped>
      <v-list>
        <v-list-item to="/">
          <v-list-item-action>
            <v-icon>mdi-account</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Profile</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/workspace" v-if="$store.state.workSpace.State">
          <v-list-item-action>
            <v-icon>mdi-laptop</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Workspace</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app clipped-left>
      <div v-if="loggedIn" v-ripple class="burger-icon-holder" @click="drawer = !drawer">
        <div class="burger-icon" :class="drawer ? 'open' : ''">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <router-link to="/" title="Home">
        <v-img
          alt="Ikano logo"
          class="shrink mr-2"
          contain
          src="@/assets/ikanoLogo.svg"
          transition="scale-transition"
          width="70"
        />
      </router-link>
      <v-toolbar-title>Selfservice portal {{ stageMsg }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <div v-if="loggedIn">
        <span class="d-none d-md-inline-block">Logged in as: {{ loggedIn }}</span>
        <v-menu transition="slide-y-transition" offset-y open-on-hover v-model="ddOpen">
          <template v-slot:activator="{ on }">
            <v-btn text v-on="on">
              User options
              <v-icon>
                {{
                ddOpen ? "mdi-chevron-up" : "mdi-chevron-down"
                }}
              </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="signOut">
              <v-list-item-icon>
                <v-icon>mdi-logout</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Sign out</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-app-bar>

    <v-content>
      <v-container>
        <router-view />
      </v-container>
    </v-content>

    <v-snackbar v-model="openSnackbar" :timeout="5000">
      {{ snackbarMsg }}
      <v-btn color="red" text @click="openSnackbar = false">Close</v-btn>
    </v-snackbar>

    <v-footer app>
      <span>&copy; 2020</span>
    </v-footer>
  </v-app>
</template>

<script>
import EventBus from "./utility/Eventbus";

export default {
  name: "App",
  components: {},

  data: () => ({
    drawer: false,
    openSnackbar: false,
    snackbarMsg: "",
    ddOpen: false,
    workspace: {},
  }),
  methods: {
    signOut() {
      this.$store.dispatch("logout");
      this.$router.go("/");
      this.drawer = false;
    },
    goTo(path) {
      this.$route.path !== path && this.$router.go(path);
    },
  },
  async created() {
    EventBus.$on("login", (success) => {
      this.drawer = success;
    });
    // sncakbar
    EventBus.$on("snackbar", (msg) => {
      this.openSnackbar = true;
      this.snackbarMsg = msg;
    });
    EventBus.$on("idleVue_onIdle", () => {
      this.$store.commit("setIdleFrom", new Date());
    });
    EventBus.$on("idleVue_onActive", () => {
      if (!this.loggedIn) {
        return;
      }
      const idleFrom = this.$store.state.idleFrom;

      const FIFTEEN_MINS = 15 * 60 * 1000; /* ms */
      if (idleFrom && new Date() - idleFrom > FIFTEEN_MINS) {
        this.signOut();
        EventBus.$emit(
          "snackbar",
          "You have been logged out due to inactivity"
        );
      }
      this.$store.commit("setIdleFrom", undefined);
    });

    await this.$store.dispatch("checkIfLoggedIn");
  },
  computed: {
    stageMsg() {
      if (!process.env.VUE_APP_BASE_URL) {
        return;
      }
      return process.env.VUE_APP_BASE_URL.includes("/dev")
        ? "<DEVELOPMENT>"
        : "";
    },
    loggedIn() {
      return this.$store.state.loggedIn;
    },
    isIdle() {
      return this.$store.state.idleVue.isIdle;
    },
  },
};
</script>

<style scoped lang="scss">
ul {
  list-style: none;
  padding: 0 !important;

  li {
    &:not(:last-child) {
      border-bottom: 1px dotted white;
    }
    padding: 0.5em 0;
  }
}
.burger-icon-holder {
  width: 45px;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  margin: 0 0.5rem 0 -0.5rem;
  cursor: pointer;
  &:hover {
    background-color: #ededed;
    transition: background-color 0.3s;
  }
  .burger-icon {
    width: 18px;
    height: 13px;
    position: relative;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: 0.5s ease-in-out;
    -moz-transition: 0.5s ease-in-out;
    -o-transition: 0.5s ease-in-out;
    transition: 0.5s ease-in-out;
    span {
      display: block;
      position: absolute;
      height: 2px;
      width: 100%;
      background: #636363;
      border-radius: 9px;
      opacity: 1;
      left: 0;
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
      -webkit-transition: 0.25s ease-in-out;
      -moz-transition: 0.25s ease-in-out;
      -o-transition: 0.25s ease-in-out;
      transition: 0.25s ease-in-out;
      &:nth-child(1) {
        top: 0px;
      }
      &:nth-child(2),
      &:nth-child(3) {
        top: 5px;
      }
      &:nth-child(4) {
        top: 10px;
      }
    }
    &.open {
      span {
        &:nth-child(1) {
          top: 5px;
          width: 0%;
          left: 50%;
        }
        &:nth-child(2) {
          -webkit-transform: rotate(45deg);
          -moz-transform: rotate(45deg);
          -o-transform: rotate(45deg);
          transform: rotate(45deg);
        }
        &:nth-child(3) {
          -webkit-transform: rotate(-45deg);
          -moz-transform: rotate(-45deg);
          -o-transform: rotate(-45deg);
          transform: rotate(-45deg);
        }
        &:nth-child(4) {
          top: 10px;
          width: 0%;
          left: 50%;
        }
      }
    }
  }
}
</style>
